/**
 * @generated SignedSource<<4d29f40ba976cb9c05c96ad86af2a2aa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type FavoriteCell542BadPattern$data = {
  readonly __id: string;
  readonly isFavourite: boolean | null | undefined;
  readonly " $fragmentType": "FavoriteCell542BadPattern";
};
export type FavoriteCell542BadPattern$key = {
  readonly " $data"?: FavoriteCell542BadPattern$data;
  readonly " $fragmentSpreads": FragmentRefs<"FavoriteCell542BadPattern">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "FavoriteCell542BadPattern",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isFavourite"
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__id"
        }
      ]
    }
  ],
  "type": "JiraFavouriteValue"
};

(node as any).hash = "ff42658d1125ce8b6397f9ea849f29a3";

export default node;
